import { render, staticRenderFns } from "./delivery-list-row.vue?vue&type=template&id=350087ec&scoped=true&"
import script from "./delivery-list-row.vue?vue&type=script&lang=js&"
export * from "./delivery-list-row.vue?vue&type=script&lang=js&"
import style0 from "./delivery-list-row.vue?vue&type=style&index=0&id=350087ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350087ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VIcon,VLayout})
